<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>Terminal - {{this.subTitle}}</h2>
			</b-col>
			<!--Gear Icon-->
			<b-col lg="6">
				<!-- <b-btn class="pull-right" v-b-popover.hover.top="'Select Datapoints'" variant="info" @click="configTable = true"><i class="fa fa-cog"></i></b-btn> -->
				<b-dropdown :disabled="edit" class="pull-right" right variant="info" no-caret>
					<template slot="button-content">
						<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item @click="editTerminal">Edit</b-dropdown-item>
					<b-dropdown-item @click="deleteTerminal">Delete</b-dropdown-item>
				</b-dropdown>
			</b-col>
		</div>

		<div>
			<b-card v-if="loadingData">
				<b-col cols="12" sm="12" md="12" lg="12">
					<p class="text-center">
						<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
					</p>
				</b-col>
			</b-card>
			<div v-else>
				<b-card v-if="found">
					<b-row>
						<b-col md="8">
							<b-form-group :label-cols="4" id="L1" label="Terminal Name" label-for="TerminalNameID" horizontal>
								<b-form-input class="plaintext-input" v-show="!edit" plaintext id="TerminalNameID" v-model="model.terminal_name" type="text"></b-form-input>
								<b-form-input class="plaintext-input" v-show="edit" id="TerminalNameID" v-model="model.terminal_name" type="text"></b-form-input>
							</b-form-group>
							<b-form-group v-if="!edit" :label-cols="4" horizontal label="Petrotranz Business" label-for="ptty">																  
								<b-form-input   v-if="model.petrotranz!=null" class="plaintext-input"  plaintext id="ptty" v-model="model.petrotranz.name" type="text"></b-form-input>		
							</b-form-group>
							<b-form-group  v-else :label-cols="4" horizontal label="Petrotranz Business" label-for="ptty1">
								<b-form-input autocomplete="off" class="plaintext-input"  id="ptty1" @keydown.native=keyMonitor($event) v-model="model.filter" placeholder="Search Filtered starting by ... (minimum 3 char)" type="text" @input="veo"></b-form-input>
								<b-form-select v-show='suggest' :select-size=size :disabled="petrotranz.length==0" value-field="id" text-field="name" id="ptty1" v-model="model1.petrotranz_company_id" :options="petrotranz"  @input="select_petrotranz()"/>							
								<div v-show='ready'>
									<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i>
								</div>
							</b-form-group> 

							<div slot="footer" v-show="edit">
								<b-button @click="updateTerminal" size="sm" variant="primary"><i class="fa fa-edit"></i> Update</b-button>
								<b-button @click="editTerminal" size="sm"><i class="fa fa-ban"></i> Cancel</b-button>
							</div>
						</b-col>
					</b-row>
					<!-- </b-tab> -->
				</b-card>
				<b-row v-else>
					<b-col cols="12" sm="12" md="12" lg="12">
						<br>
						<p class="text-center text-danger">
							<i class="icon fa-lg icon-puzzle"></i><br>{{notFoundMessage}}
						</p>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
</template>

<script>
	import term_service from './term_service'
	export default {
		name: 'TerminalDetails',
		created: function() {
			this.getTerminalData()
		},
		props: {
			id: {
				type        : String,
				default     : 0
			}
		},
		data() {
			return {
				subTitle        : '',
				edit            : false,
				found           : false,
				notFoundMessage : 'Not found',
				model           : {
					terminal_name	: '',
					petrotranz      : null,    // petrotranz business
					filter          : '',	   // petrotranz business
				},
				updateData      : null,
				originalData    : null,
                loadingData     : true,
                terminalId      : null,
				// petrotranz
				petrotranz 			: [],
				petrotranz_origin 	: [],
				ready               : false,
				suggest             : true,
				model1 : {
					petrotranz_company_id: {id:null,name:''},
				},
				size                : 6,
				offset              : '',
			}
		},
		methods: {
			editTerminal() {
				if (this.edit) {
					this.edit = false
					this.restoreOriginalData()
				} else {
					this.setupFields()
					this.edit = true
				}
			},
			restoreOriginalData() {
				let model = {
					...this.originalData,
				}
				this.model = model
			},
			setupFields() {
				if (this.model.petrotranz !== null) {
					this.model1 = {
						petrotranz_company_id: this.model.petrotranz
					}
				} else {
					this.model1 = {
						petrotranz_company_id: {id:null,name:''},
					}
				}
			},
			getTerminalData() {
				term_service.getBy(this.id)
					.then(data => {
						if (data.status == 'success') {
							this.originalData   = data.terminal
							this.terminalId     = this.id
							this.loadingData    = false
							this.found          = true
							this.petrotranz 	= data.petrotranz
							this.petrotranz_origin = data.petrotranz
							this.restoreOriginalData()	
							this.subTitle       = this.originalData.terminal_name
						}else {
              this.$swal(data.status, data.message, data.status)
              this.loadingData = false
              return

            }
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			okToUpdate() {
				if (this.model.terminal_name === undefined || this.model.terminal_name.trim().length == 0) {
					this.$swal('Alert!', 'Terminal Name can not be empty', 'warning')
					return false
				} 
				return true
			},
            updateTerminal () {
                if (!this.okToUpdate()) {
					return
				}
				this.model.petrotranz = this.model1.petrotranz_company_id
				console.log(this.model)
				term_service.update(this.terminalId, this.model)
					.then((data) => {
						this.$swal(data[0], data[1], data[0])
							.then((result) => {
								this.getTerminalData()
							})
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
					this.edit=false
			},
			deleteTerminal(item) {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to delete this Terminal: " + this.model.terminal_name + " ?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						term_service.delete(this.terminalId)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									this.$router.replace('/terminals')
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
			},
			select_petrotranz() {
				this.size 			= 1
				//let loc 			= this.model1.petrotranz_company_id.name
				//let loc_1 = loc.split("(")
				this.model.filter 	= this.model1.petrotranz_company_id.name
				//this.model1.petrotranz_company_id.name = loc_1[0]
				this.suggest 		= false
			},
			filter_p(check_filter) {
				this.size = 6
				if (this.model.filter!=='' && this.model.filter.length>2) {
					let filter = {filter:this.model.filter}
					this.ready = true
					term_service
					term_service.petrotranz(filter)
							.then(data => {
								if (data.status == 'success') {
									if (this.model.filter==check_filter) {
										this.petrotranz = data.petrotranz
									}								
									this.ready = false
								} else {
									this.$swal(data.status, data.message, data.status)
									this.ready = false
									return
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
								this.ready = false
					}) 
					console.log('--api---')
				}
			},
			veo() {
				if (this.offset==="Delete") {
					this.petrotranz = []
					this.filter_p(this.model.filter)
				}
			},
						// Selecting when pressing Enter
			keyMonitor(evt) {
				if(evt.key.match(/[a-zA-Z0-9,/,-]/i)===null) {
						evt.preventDefault();
						return					
				} else {
					evt 		= (evt) ? evt : window.event;
					let key 	= evt.key
					this.offset = key
					this.suggest = true
					if (key == "NumLock" || key == "ScrollLock" || key == "Insert" || key == "Home" || key == "End" || key == "PageUp" || key == "PageDown" || key == "Shift" || key == "AltGraph" || key == "Control" || key == "Tab" || key == "CapsLock" || key == "Alt" || key == "Enter" || key == "ArrowLeft" || key == "ArrowRight" || key == "ArrowUp" || key == "ArrowDown")  {
						return
					} else if (key == "Backspace" ) {
						this.petrotranz 	= []
						let filter_txt 		= this.model.filter
						let nn 				= filter_txt.length - 1
						if (nn>0) {
							this.model.filter = filter_txt.substring(0, nn)
							this.filter_p(this.model.filter)
							return
						} else {
							this.model.filter  = ''
							return
						}
						
					} else if (key == "Delete" ) {
						return
					} else {
						this.petrotranz 	= []
						let filter_txt 		= this.model.filter
						filter_txt 			= filter_txt + key
						this.model.filter 	= filter_txt
						this.filter_p(this.model.filter)	
						return					
					}
				}
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/terminals/terminal.vue